<template>
    <TopNav></TopNav>
		<h1>Circle Calculator</h1>
		<fieldset>
      <legend>Circle Calculator</legend>
      <label for="ce">Radius:</label> <input type="number" v-model.number="radius" step="any" autofocus id="ce">
      &nbsp;
      <label for="ce">
        <select v-model="selected">
          <option v-for="option in options" v-bind:value="option.value" v-bind:key="option.text">
            {{ option.text }}
          </option>
        </select>
      </label>
		<br><br>
      Area: <span class="blue">{{ areaFormatted }} {{ selected }}<sup>2</sup></span>
      <br>
      Circumference: <span class="blue">{{ circumferenceFormatted }} {{ selected }}</span>
		</fieldset>
</template>

<script>
import TopNav from './components/TopNav.vue'

export default {
  name: "Circle",
  data() {
    return {
      formatter: new Intl.NumberFormat('en-US', {
        maximumFractionDigits: 5
      }),
      radius: 0,
      areaFormatted: 0,
      circumferenceFormatted: 0,
      selected: "cm",
      options: [
        {text: "mm", value: "mm"},
        {text: "cm", value: "cm"},
        {text: "m", value: "m"},
        {text: "km", value: "km"},
      ]
    }
  },
  components: {
    TopNav
  },
  watch: {
    radius: function (newValue) {
      let area = Math.PI * Math.pow(newValue, 2);
      this.areaFormatted = this.formatter.format(area);

      let circumference = 2 * Math.PI * newValue;
      this.circumferenceFormatted = this.formatter.format(circumference);
    }
  }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

body {
  margin: 1em auto;
  margin-top: 0;
  max-width: 40em;
  font-family: Arial, Helvetica, sans-serif;
}

footer section a {
  margin: 20px;
}

.blue {
    color: blue;
}
</style>
